<div class="image-selector-container">
    <sera-image-container
        [imageItems]="images"
        [columnGapInPx]="8"
        [rowGapInPx]="8"
        [multiSelect]="true"
        [transparentImages]="true"
        [numberOfColumns]="numberOfColumns"
        (imageSelectionChangedMulti)="onImageSelectionChanged($event)" />
</div>
